export default __webpack_public_path__ + "static/media/settings.8248f8d4.png";